import React from 'react';
import { useState } from 'react';
import Icon, { IconType } from '../../../icons/Icon';
import { Feedback } from '../../Feedback/feedback';
import TextInput from '../TextInput';

interface PasswordInputProps {
  disabled?: boolean;
  value?: string;
  onChange: (password: string) => void;
  placeholder?: string;
  label?: string;
  validate?: boolean;
}

function validatePassword(password: string) {
  return password.match(/(?=.{8})(?=.*[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~])(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/g) !== null;
}

export default function PasswordInput({
  value,
  onChange,
  placeholder,
  label,
  validate = false,
  disabled = false,
}: PasswordInputProps) {
  const [showing, setShowing] = useState(false);

  return (
    <TextInput
      disabled={disabled}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      label={label}
      type={showing ? 'text' : 'password'}
      feedback={value => {
        if (!validate) return;
        if (!validatePassword(value)) return { type: Feedback.Type.error, text: 'Invalid password!' };
      }}
      trailing={<Icon type={IconType.eye} size={'h-4 w-4'} onClick={() => setShowing(showing => !showing)} />}
    />
  );
}
